export default [
  {
    path: '/importador-dados',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Importador de Dados Histórico',
        path: 'historico',
        component: () => import('@/views/importadorDados/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'Importador de Dados' }]
        }
      },
      {
        name: 'Importador de Dados Nova',
        path: 'novo',
        component: () => import('@/views/importadorDados/Add.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Dados', path: '/dados' },
            { name: 'Importador de Dados', path: '/importador-dados/historico' },
            { name: 'Nova Importação' }
          ]
        }
      }
    ]
  }
];
